export default {"src":"/_next/static/media/icon_filter_arrow_down.5a442b51.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};